import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const HeroSectionHealthcare = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);
  return <>
      <section className="relative w-full bg-black min-h-[100vh] py-12 overflow-hidden" data-id="element-130">
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden bg-black" data-id="element-131">
          <div className="absolute inset-0 w-full h-full overflow-hidden" data-id="element-132">
            {isMobile ? <iframe src="https://player.vimeo.com/video/1128094568?background=1&autoplay=1&loop=1&byline=0&title=0&muted=1" allow="autoplay; fullscreen" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100vw',
            height: '100vh',
            minWidth: '100%',
            minHeight: '100%',
            transform: 'translate(-50%, -50%) scale(1.5)',
            objectFit: 'cover',
            zIndex: -1,
            border: 'none'
          }} title="Mobile Wall Street Background Video" data-id="element-133"></iframe> : <iframe src="https://player.vimeo.com/video/1127157880?background=1&autoplay=1&loop=1&byline=0&title=0&muted=1" allow="autoplay; fullscreen" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100vw',
            height: '100vh',
            minWidth: '100%',
            minHeight: '100%',
            transform: 'translate(-50%, -50%) scale(1.5)',
            objectFit: 'cover',
            zIndex: -1,
            border: 'none'
          }} title="Wall Street Background Video" data-id="element-134"></iframe>}
          </div>
          <div className="absolute inset-0 bg-black bg-opacity-45 z-10" data-id="element-135"></div>
        </div>
        <div className="relative z-20 w-full mx-auto py-8 px-4 sm:px-6 md:px-8 flex flex-col justify-center min-h-[90vh]" data-id="element-136">
          <div className="max-w-3xl mx-auto text-center" data-id="element-137">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7
          }} className="mb-6" data-id="element-138">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-24 sm:w-28 md:w-32" data-id="element-139" />
            </motion.div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.05
          }} className="libre-caslon-text-regular text-base sm:text-lg text-[#ffdf07] font-semibold mb-4 leading-relaxed px-2" data-id="element-140">
              Attention chiropractors, dentists, and med spas doing
              $1–$20M/yr...
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.1
          }} className="mb-4" data-id="element-141">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/chtVcNmQ1BGBSeKcw4Bkqi/Untitled-2_%2829%29.png" alt="Wall Street Education, Without Wall Street Fees" className="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl" data-id="element-142" />
            </motion.div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.2
          }} className="libre-caslon-text-regular text-lg sm:text-xl md:text-2xl text-white mb-6 leading-relaxed px-2" data-id="element-143">
              Our exclusive 10-Day Challenge guarantees to help protect what
              your clinic is truly worth without falling into the traps that
              cost{' '}
              <span className="relative inline-block" data-id="element-144">
                <span className="absolute inset-0 bg-[#ffdf07] animate-highlight-slide animation-delay-500 rounded-md" data-id="element-145"></span>
                <span className="relative text-black font-bold px-2 py-1" data-id="element-146">
                  98% of owners millions.
                </span>
              </span>
              
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.4
          }} className="libre-caslon-text-regular text-sm text-white mb-3 px-2" data-id="element-147">
              Step 1: Watch the short video
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.5
          }} className="max-w-sm sm:max-w-md md:max-w-xl lg:max-w-2xl mx-auto mb-6" data-id="element-148">
              <div className="relative shadow-2xl rounded-lg overflow-hidden" data-id="element-149">
                <wistia-player media-id="ryfwlsyz5l" aspect="1.900990099009901" data-id="element-150"></wistia-player>
              </div>
            </motion.div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.6
          }} className="libre-caslon-text-regular text-sm text-white mb-3 px-2" data-id="element-151">
              Step 2: Apply now to claim one of the 5 FREE pilot spots before
              they're gone.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.7
          }} className="flex justify-center mb-4" data-id="element-152">
              <div className="relative" data-id="element-153">
                <div className="button-border-light" data-id="element-154"></div>
                <motion.button onClick={() => setIsModalOpen(true)} whileHover={{
                scale: 1.05,
                boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
              }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-8 sm:px-10 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-155">
                  Apply for the Challenge Now
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <AnimatePresence data-id="element-156">
        {isModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90" onClick={() => setIsModalOpen(false)} data-id="element-157">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="relative w-full max-w-4xl h-[90vh] bg-white rounded-lg shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-158">
              <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 transition-colors" data-id="element-159">
                <XIcon size={24} data-id="element-160" />
              </button>
              <iframe src="https://form.typeform.com/to/Z4eXKwXk" className="w-full h-full" frameBorder="0" title="Application Form" data-id="element-161" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};
export default HeroSectionHealthcare;